@if (!readonly) {
  <div class="input-group">
    <input
      type="text"
      mwlFlatpickr
      [options]="flatpickrOptions"
      [id]="'checkDate-' + unique"
      [formControl]="setDateFormControl"
      (flatpickrOpen)="onOpen($event)"
      (flatpickrClose)="onClose($event)" />
    @if (clearable && !isEmpty) {
      <span
        class="input-group-clear"
        title="Löschen"
        (click)="clearInput()"
        >×</span
      >
    }
  </div>
} @else {
  <div class="text-like-form">
    {{
      (setDateFormControl.value?.[0]
        | date: (monthSelect ? "MMMM YYYY" : enableTime ? "short" : "shortDate") : undefined : "de-AT") ?? "-"
    }}
  </div>
}
